<template>
    <a href="#" class="url--link">{{ name }}</a>
</template>

<script>
export default {
    name: "UnitList",
    props: {
        name: String
    }
};
</script>